import styled from '@emotion/styled'

export const Wrappertitle = styled.div`
  width: 100%;
  height: 30px;
  margin: 0 0 20px 0;
`
